import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, InputGroup, Label, InputGroupText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../../../context';
import debounce from 'lodash.debounce';

const PluginSearchInput = () => {
    const dispatch = useDispatch();

    const updatePluginsListWithFilter = useCallback(
        (string) => dispatch(actions.missionControl.setFilter(string)),
        [dispatch]
    );

    const changeHandler = (event) => {
        updatePluginsListWithFilter(event.target.value);
    };

    const debouncedChangeHandler = useMemo(
        () => debounce(changeHandler, 400),
        // eslint-disable-next-line
        []
    );

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    const filterOutput = (e) => {
        e.preventDefault();
        dispatch(actions.missionControl.setCurrentPage(1));
    };

    const focusSearchTextInputField = () =>
        setTimeout(() => document.getElementById('searchBar').focus(), 100);
    const blurSearchTextInputField = () =>
        document.getElementById('searchBar').blur();

    useEffect(() => {
        focusSearchTextInputField();
        return () => {
            blurSearchTextInputField();
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    return (
        <Form className="d-flex justify-content-center" onSubmit={(e) => filterOutput(e)}>
            <InputGroup className="text-center" >
                <Label for="searchBar" className="text-center "></Label>
                <Input
                    sm={8}
                    className="text-center"
                    type="search"
                    name="search"
                    id="searchBar"
                    placeholder="Search Plugins"
                    style={{ borderRadius: '0.2rem 0 0 0.2rem' }}
                    onChange={(e) => {
                        e.persist();
                        debouncedChangeHandler(e);
                    }}
                />
                <InputGroupText
                    onClick={(e) => filterOutput(e)}
                    className="bg-white hoverable no-border"
                    style={{ borderRadius: '0 0.2rem 0.2rem 0' }}>
                    <FontAwesomeIcon icon="search" />
                </InputGroupText>
            </InputGroup>
        </Form>
    );
};

export default PluginSearchInput;